import React from 'react';
import usePageSEO from '@/hooks/usePageSEO';

const LegalNotice = () => {
  usePageSEO({
    title: "Mentions légales | Bio Beauté Zen",
    description: "Mentions légales de Bio Beauté Zen : identification de l'entreprise, hébergement, propriété intellectuelle et protection des données.",
    canonical: "https://biobeautezen.com/mentions-legales",
    noindex: true
  });
  
  return <div className="pt-24 pb-16">
      <div className="container mx-auto px-4 max-w-4xl">
        <h1 className="text-3xl font-playfair font-bold text-bbz-text mb-8">Mentions Légales</h1>
        
        <div className="space-y-8">
          <section>
            <h2 className="text-xl font-semibold mb-4">Identification de l'entreprise</h2>
            <div className="bg-bbz-beige/10 p-6 rounded-lg">
              <p className="mb-2"><strong>Nom de l'entreprise :</strong> Bio Beauté Zen</p>
              <p className="mb-2"><strong>Forme juridique :</strong> Entreprise individuelle</p>
              <p className="mb-2"><strong>Responsable de la publication :</strong> Mme Valérie Alric</p>
              <p className="mb-2"><strong>Siège social :</strong> 1420 Chemin de Moulares, 34070 Montpellier</p>
              <p className="mb-2"><strong>Téléphone :</strong> 04 99 53 83 08</p>
              <p className="mb-2"><strong>Email :</strong> biobeautezen.institut@gmail.com</p>
              <p className="mb-2"><strong>SIRET :</strong> 42162818100032</p>
              
            </div>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-4">Hébergement</h2>
            <div className="bg-bbz-beige/10 p-6 rounded-lg">
              <p className="mb-2">Ce site est hébergé par :</p>
              <p className="mb-2"><strong>Nom de l'hébergeur :</strong> Vercel Inc.</p>
              <p className="mb-2"><strong>Adresse :</strong> 340 S Lemon Ave #4133, Walnut, CA 91789, États-Unis</p>
              <p><strong>Site web :</strong> https://vercel.com</p>
            </div>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-4">Propriété intellectuelle</h2>
            <div className="bg-bbz-beige/10 p-6 rounded-lg">
              <p className="mb-4">
                L'ensemble de ce site (structure, textes, logos, images, vidéos, sons, etc.) est la propriété exclusive 
                de Bio Beauté Zen ou fait l'objet d'une autorisation d'utilisation.
              </p>
              <p className="mb-4">
                Toute représentation totale ou partielle de ce site par quelque procédé que ce soit, 
                sans autorisation expresse de l'exploitant du site est interdite et constituerait une contrefaçon 
                sanctionnée par les articles L.335-2 et suivants du Code de la propriété intellectuelle.
              </p>
              <p>
                Les marques et logos figurant sur le site sont des marques déposées. 
                Leur mention n'accorde en aucune manière une licence ou un droit d'utilisation quelconque desdites marques, 
                qui ne peuvent donc être utilisées sans le consentement préalable et écrit du propriétaire de la marque.
              </p>
            </div>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-4">Protection des données personnelles</h2>
            <div className="bg-bbz-beige/10 p-6 rounded-lg">
              <p className="mb-4">
                Conformément à la loi Informatique et Libertés du 6 janvier 1978 modifiée, 
                et au Règlement Général sur la Protection des Données (RGPD) 2016/679 du Parlement européen et du Conseil du 27 avril 2016, 
                vous disposez d'un droit d'accès, de rectification et de suppression des données qui vous concernent.
              </p>
              <p className="mb-4">
                Vous pouvez exercer ce droit en nous contactant par email à : biobeautezen.institut@gmail.com
              </p>
              <p>
                Pour en savoir plus sur la façon dont nous traitons vos données, 
                veuillez consulter notre <a href="/politique-confidentialite" className="text-bbz-text underline hover:text-bbz-green">Politique de confidentialité</a>.
              </p>
            </div>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-4">Cookies</h2>
            <div className="bg-bbz-beige/10 p-6 rounded-lg">
              <p className="mb-4">
                Ce site utilise des cookies pour améliorer votre expérience de navigation.
              </p>
              <p>
                Pour plus d'informations sur l'utilisation des cookies, 
                veuillez consulter notre <a href="/politique-confidentialite" className="text-bbz-text underline hover:text-bbz-green">Politique de confidentialité</a>.
              </p>
            </div>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-4">Contact</h2>
            <div className="bg-bbz-beige/10 p-6 rounded-lg">
              <p className="mb-2">Pour toute question concernant ces mentions légales, vous pouvez nous contacter à l'adresse email suivante : biobeautezen.institut@gmail.com</p>
            </div>
          </section>

          <p className="text-sm text-bbz-text/70 mt-8">
            Dernière mise à jour : {new Date().toLocaleDateString('fr-FR', {
            year: 'numeric',
            month: 'long',
            day: 'numeric'
          })}
          </p>
        </div>
      </div>
    </div>;
};

export default LegalNotice;
